import { render } from "./CompanyMaintaincou.vue?vue&type=template&id=a70e74d6"
import script from "./CompanyMaintaincou.vue?vue&type=script&lang=js"
export * from "./CompanyMaintaincou.vue?vue&type=script&lang=js"

import "./CompanyMaintaincou.vue?vue&type=style&index=0&id=a70e74d6&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__